module.exports = __webpack_public_path__ + "img/loading.463d8f4b.gif";